import React from "react";
import { Modal, Button } from "antd";
import { useSelector } from "react-redux";
import Question from "../../../assets/ppt/Question.svg";

const ModalAI = ({ onSubmitOk, aiInsightModal, setAiInsightModal }) => {
  const authParams = useSelector((state) => state.Authentication.authParams);

  const handleCancelModal = () => {
    setAiInsightModal(false);
  };

  const handleCancel = () => {
    setAiInsightModal(false);
    onSubmitOk(false);
  };

  const handleOK = () => {
    setAiInsightModal(false);
    onSubmitOk(true);
  };

  return (
    <>
      <Modal
        title={null}
        visible={aiInsightModal}
        onCancel={handleCancelModal}
        width={760}
        className={`chart_list-modal ${
          authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
        }`}
        footer={[
          <Button
            type="button"
            className="btn_Clear"
            style={{ minWidth: "5.6rem" }}
            onClick={handleCancel}
          >
            NO
          </Button>,
          <Button
            type="primary"
            onClick={handleOK}
            className="ant-btn-primary_blue"
          >
            Yes
          </Button>,
        ]}
      >
        <div>
          <div className="text_heading d-flex align-items-center fontSize-16 mb-2 font-weight500">
            <img
              src={Question}
              alt="Question Mark Icon"
              className="mr-15"
              style={{ maxWidth: "4rem" }}
            />
            <div>
              <div className="mb-0 text_heading-Slab text-transform__none">
                Do you want to Download PDF with AI Insights ?
              </div>
              <div className="text_regular" style={{ marginTop: "1rem" }}>
                AI Insight provides information about your graph to help you
                better understand the data
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalAI;
